// ◉ xlVISION · Powering Business Together!
// © ExcelVision, Lda. — Braga, Portugal
// ( ·:·●●·:· ) xlVISION | Powering Business Together!
//
// ============================================================================
// A LISTA ÚNICA DAS ACÇÕES DA FORMAÇÃO DOS PLANEADORES
// ============================================================================
//
// 📄 Desenho: `docs/superpowers/specs/2026-10-27-formacao-e-testes-design.md` (§5, §7, §8).
//
// 📌 **Uma só fonte, três leitores:** a página «Formação» (marcas ✅/⚠️ por ação), os sete
//    guias (um bloco com `id="<comoAncora>"` por ação) e o plano de formação. Três listas
//    escritas à mão divergiam — e a que divergisse era a que ninguém conferia.
//
// Os dados vivem em `acoes-da-formacao.json`, ao lado, para que a conferência de cobertura
// (`tools/formacao/conferir-cobertura.mjs`, em Node puro) os leia sem compilar TypeScript.
// Este módulo só lhes dá os tipos.
// ============================================================================

import dados from './acoes-da-formacao.json';

/** Uma ação que o planeador testa na cópia de ensaio (ou vê na demonstração). */
export interface AcaoDaFormacao {
  /** Chave estável: a página grava as marcas por ela — mudá-la orfaniza as marcas já feitas. */
  readonly id: string;
  readonly sessao: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  /** O que fazer, em linguagem de quem conhece o Excel. */
  readonly titulo: string;
  /** O `id` do bloco no guia da sessão (`/formacao/guias/sessao-N.html#<comoAncora>`). */
  readonly comoAncora: string;
  // 📗 2026-10-30 · Saiu o campo `mudaPlanoReal` (o aviso «isto muda também o plano real —
  //    teste com uma alteração pequena e desfaça logo»). Cliente: «tudo pode ser editado, os dados
  //    não são reais». Os únicos leitores eram esse aviso (página, guias, apresentações, plano).
  //    O que não se desfaz (repor na fila, dias passados, fechados) diz-se no texto da ação.
  /** `copia`: o planeador testa na cópia de ensaio · `demo`: só se vê na demonstração. */
  readonly ondeTestar: 'copia' | 'demo';
  /** Os ids do `INVENTARIO` que esta ação cobre. */
  readonly funcionalidades: readonly string[];
}

/** Uma funcionalidade da aplicação — a unidade sobre a qual se confere «nada ficou para trás». */
export interface FuncionalidadeDoInventario {
  readonly id: string;
  readonly rotulo: string;
}

export const SESSOES: readonly { readonly n: number; readonly data: string; readonly tema: string }[] =
  dados.sessoes;

/** O inventário completo das funcionalidades que um planeador usa ou precisa de saber que existem. */
export const INVENTARIO: readonly FuncionalidadeDoInventario[] = dados.inventario;

/**
 * As ações, por ordem de sessão.
 * ⚠️ O `as` estreita `sessao` e `ondeTestar` (o JSON dá `number` e `string`); os valores são
 *    conferidos pelas provas de `acoes.test.ts`, que é onde um valor fora do sítio se apanha.
 */
export const ACOES: readonly AcaoDaFormacao[] = dados.acoes as readonly AcaoDaFormacao[];
